<div class="header-left">
  <ng-content select="header-left"></ng-content>
</div>
<div class="header-right">
  <ng-content select="header-right"></ng-content>
</div>
